export const MAKE_MOVE = "MAKE_MOVE";
export const CHANGE_GAME_MODE = "CHANGE_GAME_MODE";
export const RESTART_GAME = "RESTART_GAME";
export const CHANGE_ROUTE = "CHANGE_ROUTE";
export const CHANGE_TO_RECORDED_TURN = "CHANGE_TO_RECORDED_TURN";
export const TOGGLE_ICON_SELECT_OPEN = "TOGGLE_ICON_SELECT_OPEN";
export const TOGGLE_ICON_SELECT_FLIPPED = "TOGGLE_ICON_SELECT_FLIPPED";
export const UPDATE_ICON_INFO = "UPDATE_ICON_INFO";
